module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackIt.0f92f5e.ttf";